// Phase 45.5.3 (CANVAS-14) — shared source-authority sort.
// Lifted out of CanvasFormSections.tsx so the new canvas-local field
// components (CanvasSelectField) reuse the SAME authority map instead of
// duplicating it. Single source of truth for the D-13 conflict ordering:
// COO (boat/trailer) > invoice > BOL > VIN > AI > AI-photo > PDF > web > manual.

import type { ProvenanceEntry } from '@/modules/inventory/types/boat.types';

// Authority order for conflict resolution (D-13): COO (boat/trailer) > invoice
// > BOL > web/AI > everything else. Lower rank = higher authority = first.
export const SOURCE_AUTHORITY: Record<string, number> = {
  'COO-boat': 0,
  'COO-trailer': 1,
  invoice: 2,
  BOL: 3,
  VIN: 4,
  AI: 5,
  'AI-photo': 6,
  PDF: 7,
  web: 8,
  manual: 9,
};

export function sortByAuthority(entries: ProvenanceEntry[]): ProvenanceEntry[] {
  return [...entries].sort((a, b) => {
    const ra = SOURCE_AUTHORITY[a.source] ?? 99;
    const rb = SOURCE_AUTHORITY[b.source] ?? 99;
    if (ra !== rb) return ra - rb;
    // Tie-break by confidence (higher first).
    return b.confidence - a.confidence;
  });
}
